<app-data-title [title]="title"></app-data-title>
<mat-card class="mat-margin-none mat-padding-none">
  <mat-grid-list [cols]="1">
    <huge-row style="flex-grow: 1; justify-content: center; align-items: center">
      @for (dataValue of dataValues; track dataValue) {
      <huge-row class="text-align-center" style="margin: 5px; flex-grow: 1">
        <div class="data-value-row-card-value">{{ dataValue.value }} </div>
        <div class="data-value-row-card-label"> {{ dataValue.label }}</div>
      </huge-row>
      }
    </huge-row>
  </mat-grid-list>
</mat-card>
